import API from './api.js'
import qs from 'qs';

        const findManyService = async (query)=>{
            const queryString = qs.stringify(query)
            return await API.get(`/streamings?${queryString}`)
        }
            const createService = async (body)=>{
            return await API.post(`streamings`, body)
        }
            const removeService = async (live_uuid, body)=>{
            return await API.delete(`streamings/${ live_uuid }`, body)
        }

export default  {
    findMany : findManyService,
    create : createService,
    remove : removeService
}

export const findMany = findManyService
export const create = createService
export const remove = removeService
